import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../access/auth.service';
import { MessageService } from '../../util/message.service';
import { ModalService } from '../../util/modal.service';
import { BrandService } from '../../pages/members/brand/services/brand.service';
import { Brand } from '../../models/brand';



@Component({
  selector: 'brands-table',
  templateUrl: './brands-table.component.html',
  styleUrls: ['./brands-table.component.scss']
})
export class BrandsTableComponent implements OnInit {
  @ViewChild('modal', { static: true }) modal!: ElementRef<HTMLDivElement>;
  @Input() brands: any = [];
  @Input() isColaborator: boolean | undefined;
  @Input() isManager: boolean | undefined;
  @Input() subsidiary: any;
  @Input() actualSearch: any;
  @Input() selectedBrand: Brand | undefined
  @Output() requestDelete = new EventEmitter<Brand>();
  private storeId: string = '';

  constructor(
    private _route: Router,
    private _service: BrandService,
    private _auth: AuthService,
    private _modalService: ModalService,
    private _messageService: MessageService,
  ) { }

  ngOnInit(): void {
    if(this._auth.getStore()) {
      this.storeId = this._auth.getStore().storeId;
    }
  }
  editar(brand: Brand) {
    this._route.navigate(['/members/brand/detailBrand', brand.id])
  }

  toggleOptions(e: HTMLImageElement | null) {
    // @ts-ignore
    let div: HTMLElement = e.parentElement
    if (div.classList.contains('options')) {
      // @ts-ignore
      div.querySelector('.box').classList.toggle('d-none')
    }

  }
  
  onDeleteClick(item: Brand): void {
    this.requestDelete.emit(item);
  }
  error(err: any) {
    if (err.error.detail) {
      this._modalService.showModalError('Ocurrio un error', err.error.detail.text)
    } else {
      this._modalService.showModalGenerico()
    }
  }

}
